import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import CallEndIcon from "@mui/icons-material/CallEnd";
import ErrorIcon from "@mui/icons-material/Error";
import AlertComponent from "../../components/common/AlertComponent";

import { observer, inject } from "mobx-react";
import {
  meetingCheck,
  startParticipant,
} from "../../utils/api/Meeting/Dashboard/Meeting";
import { getResponses } from "../../utils/api/Meeting/Dashboard/Question";

const VideoMeetingPage = ({ store, match }) => {
  const { guid } = useParams();
  const [videoUrl, setVideoUrl] = useState({});
  const [videoLink, setVideoLink] = useState("");
  const [ready, setReady] = useState(false);
  const [allowCamMic, setAllowCamMic] = useState(false);
  const [showAgreement, setShowAgreement] = useState(false);
  const [participantId, setParticipantId] = useState(null);
  const [responses, setResponses] = useState([]);
  const [showSelectedOnam, setShowSelectedOnam] = useState(null);
  const [checkedBoxes, setCheckedBoxes] = useState([]);
  const [pageCloseWarningDisplay, setPageCloseWarningDisplay] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      store.setLoadingBarStatus(true);
      window.addEventListener("beforeunload", (e) => {
        e.preventDefault();
      });

      if (store.baseUrl && guid) {
        let checkMeetingReq = await meetingCheck(
          store.baseUrl,
          store.token,
          guid
        );
        if (checkMeetingReq !== undefined && checkMeetingReq !== null) {
          if (checkMeetingReq.status === 200) {
            let responses = await getResponses(
              store.baseUrl,
              checkMeetingReq?.data?.data?.trainerId,
              checkMeetingReq?.data?.data?.meetingId,
              checkMeetingReq.data.data.participantId
            );

			setVideoUrl(checkMeetingReq?.data?.data);
			setAllowCamMic(true);
			setReady(true);
			setResponses(responses?.data?.data);
			setParticipantId(checkMeetingReq?.data?.data?.participantId);
          } else {
            store.setMessage("Görüşme bulunamadı", true, "error");
          }
        }
      } else {
        store.setMessage("Bir hata oluştu", true, "error");
      }
    };

    fetchData();
  }, [store, guid]);

  const startCall = async () => {
    if (!videoUrl.startingDate)
      await startParticipant(store.baseUrl, participantId);
    const url = videoUrl.videoUrl;
    setVideoLink(url);
  };

  const handleAgreementDialog = () => {
    if (allowCamMic) {
      if (responses?.onams?.length === 0) {
        setAllowCamMic(false);
        startCall();
      } else {
        setAllowCamMic(false);
        setShowAgreement(true);
      }
    } else {
      setShowAgreement(!showAgreement);
    }
  };

  const replaceOnams = (onamForms) => {
    const date = new Date(videoUrl.meetingDate);
    const formattedDate = date.toLocaleDateString("tr-TR");
    const formattedTime = date.toTimeString().slice(0, 5);
    console.log('videoUrl', videoUrl, date);

    const a = onamForms?.onams?.map((e) => {
      return {
        ...e,
        onamText: e?.onamText
          ?.replaceAll("#İsim Soyisim#", responses?.name)
          ?.replaceAll("#Telefon Numarası#", responses?.mobilePhone)
          ?.replaceAll("#Oturum Tarihi#", formattedDate)
          ?.replaceAll("#Oturum Saati#", formattedTime)
          ?.replaceAll("#Hemşire İsmi#", videoUrl.fullName),
      };
    });

    onamForms?.questions?.forEach((q) => {
      a.forEach((e) => {
        e.onamText = e?.onamText?.replaceAll(
          "#" + q?.questionText + "#",
          onamForms?.responses?.find((a) => a.questionId === q.questionId)
            ?.responseValue
        );
      });
    });
    return a;
  };

  const handleCheckboxes = (onam, checked) => {
    if (checked) {
      setShowSelectedOnam(onam.onamText);
      setCheckedBoxes((prevCheckedBoxes) => [...prevCheckedBoxes, onam.onamId]);
    } else {
      setCheckedBoxes((prevCheckedBoxes) =>
        prevCheckedBoxes.filter((a) => a !== onam.onamId)
      );
    }
  };

  return (
    <>
      <AlertComponent />
      {ready ? (
        !videoLink ? (
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            sx={{ width: 1, height: "100vh" }}
          >
            <img
              src="/assets/images/wholemedics-logo.png"
              alt="wholemedics"
              style={{ width: "50%" }}
            />
            <Dialog open={showAgreement} maxWidth={"sm"} fullWidth>
              <DialogContent style={{ padding: "30px" }}>
                <FormGroup>
                  {replaceOnams(responses)?.map((onam) => (
                    <FormControlLabel
                      key={onam.onamId}
                      onChange={(a) => handleCheckboxes(onam, a.target.checked)}
                      sx={{ color: "#ff5969", cursor: "pointer" }}
                      required
                      control={<Checkbox className="onam-checkbox" />}
                      label={onam.onamName}
                    />
                  ))}
                </FormGroup>
              </DialogContent>
              <DialogActions>
                <Button
                  disabled={checkedBoxes?.length !== responses?.onams?.length}
                  variant="contained"
                  color="primary"
                  onClick={() => startCall()}
                  style={{ height: "55px", float: "right" }}
                >
                  Devam Et
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog open={allowCamMic} maxWidth={"sm"} fullWidth>
              <DialogTitle id="alert-dialog-title">
                <Typography variant="body1" style={{ fontWeight: "bold" }}>
                  Bilgilendirme
                </Typography>
              </DialogTitle>
              <DialogContent>
                <Typography>
                  Değerli kullanıcımız, görüşmeyi yapabilmek için{" "}
                  <b>kamera ve mikrofon erişim izni </b>
                  gerekmektedir. Görüşmeyi karşı tarafa bildirerek istediğiniz
                  anda sonlandırabilirsiniz.
                </Typography>
                <br />
                <Typography>
                  Görüşme sırasında{" "}
                  <b>gerektiğinde ses kaydı yapılabilmektedir.</b>
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleAgreementDialog}
                  style={{ height: "55px", float: "right" }}
                >
                  Kabul Et
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog open={!!showSelectedOnam} maxWidth={"md"} fullWidth>
              <DialogContent>
                <div className="meeting-agreement" style={{ width: "100%" }}>
                  <div
                    className="container"
                    dangerouslySetInnerHTML={{ __html: showSelectedOnam }}
                  ></div>
                </div>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => setShowSelectedOnam(null)}
                  style={{ height: "55px", float: "right" }}
                >
                  Kabul Et
                </Button>
              </DialogActions>
            </Dialog>
          </Stack>
        ) : (
          <>
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              sx={{ width: 1, height: "100svh" }}
            >
              <iframe
                allow="camera; microphone; display-capture; autoplay; clipboard-write; hid"
                id="external-meeting-iframe"
                src={videoLink}
                title="Görüşme Ekranı"
                style={{
                  height: "calc(100%)",
                  width: "calc(100%)",
                  border: "0",
                }}
              />
            </Stack>

            <Box
              variant="contained"
              sx={{
                position: "fixed",
                top: 0,
                right: 0,
                zIndex: 2000,
                backgroundColor: "white",
                borderRadius: "100%",
                padding: "4px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <IconButton
                aria-label="upload picture"
                color="error"
                className="video-call-button-endcall"
                onClick={() => setPageCloseWarningDisplay(true)}
              >
                <CallEndIcon style={{ color: "#fff", fontSize: "21px" }} />
              </IconButton>
            </Box>

            <Dialog
              fullWidth
              maxWidth="xs"
              open={pageCloseWarningDisplay}
              onClose={() => setPageCloseWarningDisplay(false)}
            >
              <DialogTitle id="alert-dialog-title"></DialogTitle>
              <DialogContent style={{ paddingTop: "0" }}>
                <Grid container>
                  <Grid item xs={3}>
                    <ErrorIcon color="error" style={{ fontSize: "80px" }} />
                  </Grid>
                  <Grid item xs={9}>
                    <Typography variant="body1" style={{ fontWeight: "bold" }}>
                      Görüşmeden çıkmak istediğinize emin misiniz ?
                    </Typography>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button
                  color="primary"
                  onClick={() => setPageCloseWarningDisplay(false)}
                >
                  GERİ DÖN
                </Button>
                <Button
                  color="error"
                  variant="contained"
                  onClick={() => {
                    setVideoLink("");
                    setReady(false);
                  }}
                >
                  GÖRÜŞMEDEN AYRIL
                </Button>
              </DialogActions>
            </Dialog>
          </>
        )
      ) : (
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
          sx={{ width: 1, height: "100vh" }}
        >
          <img
            src="/assets/images/wholemedic-logo.png"
            alt="wholemedics"
            style={{ width: "50%" }}
          />
        </Stack>
      )}
    </>
  );
};

export default inject("store")(observer(VideoMeetingPage));
